import { BookingFeatureStore } from '../Storage/BookingFeatureStore';
import BookingFeatureContext from '../Contexts/BookingFeatureContext';
import { useContext } from 'react';

function useBookingFeatureStore(): BookingFeatureStore {
  return useContext(BookingFeatureContext);
}

export default useBookingFeatureStore;
